import { IBookingCalendarStore } from '../../index'
import { IToggleCreateReservation } from '../../../../actions/bookingCalendar/reservationModal/toggleReservationModal'

export default function(
  state: IBookingCalendarStore,
  action: IToggleCreateReservation,
): IBookingCalendarStore {
  if ('gtag' in window) {
    ;(window as any).gtag('event', 'conversion', {
      send_to: 'AW-927657230/_mCmCIHqwJADEI7aq7oD',
    })
  }

  return {
    ...state,
    reservationModal: {
      ...state.reservationModal,
      createForm: {
        ...state.reservationModal.createForm,
        from: action.from,
        isOpen: !state.reservationModal.createForm.isOpen,
        roomId: action.roomId,
      },
      loading: false,
      selectedTab: 0,
    },
  }
}
